import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  TextField,
  Icon,
} from "@material-ui/core";
import { coloresEmma } from "../../global/js/funciones";
import { useStyles } from "./styles";
import { MAX_CARACTERES } from "./helper";

/**
 * Modal para escribir/editar una sección del proyecto de vida.
 * Mantiene su propio estado de texto para que escribir sea fluido; al guardar
 * devuelve el valor al componente padre vía onGuardar.
 */
export default function ProyectoVidaModal({ open, seccion, valorInicial, onGuardar, onCancelar }) {
  const classes = useStyles();
  const [texto, setTexto] = useState("");

  useEffect(() => {
    if (open) setTexto(valorInicial || "");
  }, [open, valorInicial]);

  if (!seccion) return null;

  const handleChange = ({ target }) => {
    if (target.value.length <= MAX_CARACTERES) setTexto(target.value);
  };

  return (
    <Dialog open={open} maxWidth="sm" fullWidth onClose={() => onCancelar()} PaperProps={{ style: { borderRadius: 16 } }}>
      <DialogContent style={{ padding: 24 }}>
        <div className={classes.encabezado}>
          <div className={classes.logoWrapper}>
            <div className={classes.logoBubble} style={{ border: `2px solid ${seccion.color}80` }}>
              <img src={seccion.logo} alt={seccion.titulo} style={{ width: 50, height: 50, objectFit: "contain" }} />
            </div>
            <img src={seccion.lines} alt="" className={classes.lines} />
          </div>
          <div>
            <Typography variant="h6" style={{ fontWeight: 700, lineHeight: 1.2 }}>
              {seccion.titulo}
            </Typography>
            <Typography style={{ color: "#555", fontSize: "0.9rem", marginTop: 2 }}>
              {seccion.descripcionModal}
            </Typography>
          </div>
        </div>

        <div style={{ position: "relative" }}>
          <TextField
            fullWidth
            multiline
            rows={6}
            variant="outlined"
            placeholder={seccion.placeholder}
            value={texto}
            onChange={handleChange}
            inputProps={{ maxLength: MAX_CARACTERES }}
          />
          <div className={classes.contador}>
            {texto.length}/{MAX_CARACTERES}
          </div>
        </div>

        <div className={classes.consejo}>
          <Icon style={{ color: coloresEmma.secondarycolor }}>lightbulb_outline</Icon>
          <div>
            <Typography style={{ color: coloresEmma.secondarycolor, fontWeight: 700, marginBottom: 2 }}>Consejo</Typography>
            <Typography style={{ color: "#5b4a4a", fontSize: "0.85rem", lineHeight: 1.4 }}>{seccion.consejo}</Typography>
          </div>
        </div>
      </DialogContent>

      <DialogActions style={{ padding: "16px 24px 24px 24px", justifyContent: "space-between" }}>
        <Button variant="outlined" className={classes.btnCancelar} onClick={() => onCancelar()}>
          Cancelar
        </Button>
        <Button variant="contained" className={classes.btnPrimario} onClick={() => onGuardar(texto.trim())}>
          Guardar
        </Button>
      </DialogActions>
    </Dialog>
  );
}

ProyectoVidaModal.propTypes = {
  open: PropTypes.bool.isRequired,
  seccion: PropTypes.object,
  valorInicial: PropTypes.string,
  onGuardar: PropTypes.func.isRequired,
  onCancelar: PropTypes.func.isRequired,
};
